import { __assign } from "tslib";
// DS: I110
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
var ArtStageArrowL = function (props) { return (React.createElement(IconWrap, __assign({}, props),
    React.createElement("svg", { width: "27", height: "48", viewBox: "0 0 27 48", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
        React.createElement("path", { d: "M3 21L24 0l3 3L6 24l21 21-3 3L0 24l3-3z", fillRule: "evenodd" })))); };
ArtStageArrowL.displayName = 'ArtStageArrowL';
export default ArtStageArrowL;
//# sourceMappingURL=ArtStageArrowL.js.map